module.exports = __webpack_public_path__ + "img/right-expand.5f54f2be.svg";